// src/components/modals/UsernameSetupModal.js
import React, { useState } from 'react';
import Modal from '../ui/Modal';
import GlassButton from '../ui/Button';
import InputField from '../ui/Input';

const UsernameSetupModal = ({ isOpen, onSave }) => {
    const [username, setUsername] = useState('');
    const [error, setError] = useState('');

    const handleSave = () => {
        if (!username.trim()) {
            setError('Por favor, insira um nome de usuário.');
            return;
        }
        onSave(username);
    };

    return (
        <Modal isOpen={isOpen}>
            <div className="p-6 text-center">
                <h2 className="text-2xl font-bold text-white">Complete o seu Perfil</h2>
                <p className="text-gray-300 mt-2">
                    Para uma melhor experiência, por favor, defina um nome de usuário.
                </p>
            </div>
            <div className="p-6 space-y-4">
                <InputField
                    label="Nome de Usuário"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Como devemos te chamar?"
                />
                {error && <p className="text-red-400 text-sm text-center">{error}</p>}
            </div>
            <div className="p-6 flex justify-end bg-black/20 rounded-b-2xl">
                <GlassButton onClick={handleSave} className="bg-indigo-500 hover:bg-indigo-600">
                    Salvar e Continuar
                </GlassButton>
            </div>
        </Modal>
    );
};

export default UsernameSetupModal;